var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgErrorCircleExclamation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 22C2 24.6264 2.51732 27.2272 3.52241 29.6537C4.5275 32.0802 6.00069 34.285 7.85786 36.1421C9.71504 37.9993 11.9198 39.4725 14.3463 40.4776C16.7728 41.4827 19.3736 42 22 42C24.6264 42 27.2272 41.4827 29.6537 40.4776C32.0802 39.4725 34.285 37.9993 36.1421 36.1421C37.9993 34.285 39.4725 32.0802 40.4776 29.6537C41.4827 27.2272 42 24.6264 42 22C42 19.3736 41.4827 16.7728 40.4776 14.3463C39.4725 11.9198 37.9993 9.71504 36.1421 7.85786C34.285 6.00069 32.0802 4.5275 29.6537 3.52241C27.2272 2.51732 24.6264 2 22 2C19.3736 2 16.7728 2.51732 14.3463 3.52241C11.9198 4.5275 9.71504 6.00069 7.85786 7.85786C6.00069 9.71504 4.5275 11.9198 3.52241 14.3463C2.51732 16.7728 2 19.3736 2 22Z",
    stroke: "#D42015",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 14.1445V25.5731",
    stroke: "#D42015",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22 29.4609V29.4776",
    stroke: "#D42015",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorCircleExclamation);
export default __webpack_public_path__ + "static/media/ErrorCircleExclamation.db3c9dbf9b2b2aba4aeb1fc29569252a.svg";
export { ForwardRef as ReactComponent };